<template>
  <div>
    <h3 v-if="mw && mw.title" class="mb-4">{{ mw.title }}</h3>
    <template v-if="mw.content">
      <p v-for="(t, i) in mw.content" :key="i" class="mb-2">{{ t }}</p>
    </template>
    <div class="d-flex align-center mb-2">
      <v-radio-group v-model="isNew" hide-details dense mandatory class="mt-0 mr-2" :readonly="(isNew == 1 && !!id) || readonly">
        <v-radio label="Выбрать объект" :value="0"></v-radio>
        <v-radio label="Создать объект" :value="1"></v-radio>
      </v-radio-group>
      <a-input-selectapi
        :model="{
          api: '/mechti/objects/select',
          filters: {
            status: 0,
            OR: [
              { field: 'client_id', condition: '=', value: this.wizard.client.id },
              { field: 'client_id', condition: 'IS', value: null },
            ],
          },
        }"
        v-model="id"
        :config="{ dense: true, hideDetails: true }"
        :readonly="(isNew == 1 && !!id) || readonly"
        @selected="onSelect"
        dense
        :disabled="!!isNew || readonly"
        class="flex-grow-1"
      />
    </div>
    <a-form-model2
      v-if="isNew || id"
      v-model="data"
      class="mt-4"
      :model="model"
      :modelForm="modelForm"
      :values="data"
      :errors="errors"
      :config="{ dense: true, hideDetails: 'true', readonly }"
      @validate="validate($event)"
    />
    <s-tree-block :value="wizard" v-if="getAccess('contract.wizard.debug')" />

    <portal to="v-wizard-action">
      <v-btn v-if="id && !readonly" @click="onUndo">Назад</v-btn>
      <v-btn v-if="(isNew && !id) || isChanged" @click="submit">Сохранить объект</v-btn>
      <v-btn v-if="id" :disabled="isChanged" @click="onNext">Далее</v-btn>
    </portal>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, genModel, getAccess } from "@/components/mixings";
import { readonly } from "vue";

export default {
  components: {},
  mixins: [getForm, submitForm, removeEl, genModel, getAccess],
  props: {
    wizard: {
      type: Object,
      default: () => {},
    },
    mw: {
      type: Object,
      default: () => {},
    },
    defaults: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      m: this.$store.getters["config/get"].models.objects,
      model1: [],
      api: "/mechti/objects",
      isNew: 0,
      id: null,
      model: [],
      loaded: false,
      object: {},
    };
  },
  computed: {
    readonly() {
      return !!this.wizard?.estimate?.id || !!this.wizard?.contract?.template_id || (this.wizard?.services || []).length > 0;
    },
    config() {
      const c = this.mw?.config || {}; //.wizardContract;
      c.fieldsReplace.client_id.default = this.wizard.client.id;
      return c;
    },
  },
  created() {
    this.init();
  },
  watch: {
    isNew(v) {
      if (v) {
        this.id = null;
        this.updateData(this.id);
      }
    },
  },
  methods: {
    waitForEvent(eventName, payload) {
      return new Promise((resolve) => {
        this.$emit(eventName, payload, resolve);
      });
    },
    init() {
      this.loaded = !true;
      this.object = Object.assign({}, this.wizard?.object || {});
      this.id = this.object?.id || null;
      this.updateData(this.id);
      this.isNew = this.object?.isNew || 0;
    },

    onSelect(v) {
      console.log("select", v);
      this.updateData(v?.value);
    },
    afterFetchData(r) {
      if ((!this.object?.id && r) || this.wizard?.object?.id != this.data?.id) {
        this.data.client_id = this.wizard.client.id;
        this.data.object_type = 3;
        this.data.object_group = 2;
        this.data.is_investor = 0;

        this.validate("client_id");
        this.object = Object.assign({}, { id: this.data.id, data: this.getDataForModel(this.model, this.data) });
      }
      if (!r && this.object.id) this.object = {};
      this.id = this.object.id;
      //   this.wizard.objectData = Object.assign({}, this.data);
      this.calcModel();
      this.loaded = true;
    },
    calcModel(t) {
      const config = this.config;
      console.log("run calc", config);
      let model = this.calcModelConfig(config, this.m);

      this.fillFormFromModel(model);
      this.model = model;
      return model;
    },
    async beforeSave() {
      // this.data.object_type = this.type;
      return true;
    },
    afterSave(data, status) {
      if (this.isNew) this.$root._refreshDirs("object");
      this.object = Object.assign({}, { id: this.data.id, data: this.getDataForModel(this.model, this.data) });
      // this.init({ id: data.id, isNew: 1, data: data });
      this.isChanged = false;
      this.onNext();
    },
    async onUndo() {
      await this.waitForEvent("save", {});
      this.$emit("next", -1);
    },
    async onNext() {
      if (this.isNew) {
        const result = await this.waitForEvent("save", this.object);
        this.$emit("next");
      } else {
        const result = await this.waitForEvent("save", this.object);
        this.$emit("next");
      }
    },
  },
};
</script>
